module.exports = __webpack_public_path__ + "img/Blog-Image@3x.b6c739b2.png";